import { render, staticRenderFns } from "./TarifeBolgeEkle.vue?vue&type=template&id=01e17072"
import script from "./TarifeBolgeEkle.vue?vue&type=script&lang=js"
export * from "./TarifeBolgeEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports